export default __webpack_public_path__ + "static/soldout-062b4c9f09dfc2c06424a2375242ecc0.png";